import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _MAX_FIELD_LENGTHS;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import config from 'utils/config';
export var SHOW_ALL = 'all';
export var SHOW_DEFAULT = 'default';
export var SHOW_CUSTOM = 'custom';
export var SUBJECT = 'subject';
export var BODY = 'body';
export var FOOTER = 'footer';
export var LINK_TEXT = 'linkText';
export var SIGNATURE = 'signature';
export var TITLE = 'title';
export var ALLOWED_TEMPLATE_FIELDS = [SUBJECT, TITLE, SIGNATURE, LINK_TEXT, FOOTER, BODY];

// every template has those fields
var BASE_FIELDS = [SUBJECT, BODY, FOOTER];
export var MAX_FIELD_LENGTHS = (_MAX_FIELD_LENGTHS = {}, _defineProperty(_MAX_FIELD_LENGTHS, SUBJECT, 130), _defineProperty(_MAX_FIELD_LENGTHS, TITLE, 130), _defineProperty(_MAX_FIELD_LENGTHS, SIGNATURE, 1000), _defineProperty(_MAX_FIELD_LENGTHS, LINK_TEXT, 50), _defineProperty(_MAX_FIELD_LENGTHS, FOOTER, 500), _defineProperty(_MAX_FIELD_LENGTHS, BODY, 4000), _MAX_FIELD_LENGTHS);
var HUB_NAME = '{{domain.pageTitle}}';
var HUB_URL = '{{domain.origin}}';
var SENDER_NAME = '{{author.displayName}}';
var SENDER_EMAIL = '{{author.email}}';
var RECIPIENT_NAME = '%recipient.displayName%';
var RECIPIENT_FIRST_NAME = '%recipient.first_name%';
var RECIPIENT_EMAIL = '%recipient.email%';
var RECIPIENT_INVITE_LINK = '%recipient.link%';
var CONTENT_ASSET_NAME = '{{content.assetName}}';
var CONTENT_NAME = '{{content.name}}';
var CONTENT_TITLE = '{{content.title}}';
var CONTENT_URL = '{{content.url}}';
var CONTENT_COMMENT = '{{content.comment}}';
var CONTENT_REVIEW = '{{{content.review}}}';
var CONTENT_DUE_DATE = '{{content.dueDate}}';
var MEETING_TITLE = '{{meeting.meetingTitle}}';
var MEETING_DATE = '{{meeting.meetingDate}}';
var MEETING_FEEDBACK = '{{meeting.meetingFeedback}}';
var isHelixEnabled = config.helixIntegrationMode === 'helix' || config.helixIntegrationMode === 'both';
export var BASE_TAGS = [HUB_NAME, HUB_URL];
export var SENDER_TAGS = [SENDER_NAME, SENDER_EMAIL];
var BASE_RECIPIENT_TAGS = [RECIPIENT_NAME, RECIPIENT_FIRST_NAME, RECIPIENT_EMAIL];
export var RECIPIENT_TAGS = [].concat(BASE_RECIPIENT_TAGS, [RECIPIENT_INVITE_LINK]);
export var CONTENT_TAGS = [CONTENT_ASSET_NAME, CONTENT_NAME, CONTENT_TITLE, CONTENT_URL, CONTENT_COMMENT, CONTENT_REVIEW, CONTENT_DUE_DATE];
export var MEETING_TAGS = [MEETING_TITLE, MEETING_DATE, MEETING_FEEDBACK];
export var ALLOWED_EMAIL_TAGS = [].concat(BASE_TAGS, SENDER_TAGS, _toConsumableArray(RECIPIENT_TAGS), CONTENT_TAGS);
if (isHelixEnabled) {
  ALLOWED_EMAIL_TAGS.push.apply(ALLOWED_EMAIL_TAGS, MEETING_TAGS);
}

// FYI: ordered alphabetically by english title instead of TEMPLATE_MAP key
export var TEMPLATE_MAP = _objectSpread({
  newUser: {
    title: 'email_template_new_user_title',
    description: 'email_template_new_user_info',
    fields: [].concat(BASE_FIELDS, [TITLE, LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [RECIPIENT_INVITE_LINK])
  },
  resetPassword: {
    title: 'email_template_reset_password_title',
    description: 'email_template_reset_password_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS)
  },
  welcomeUser: {
    title: 'email_template_welcome_user_title',
    description: 'email_template_welcome_user_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: BASE_TAGS
  },
  newCommentNotificationAdmin: {
    title: 'email_template_comment_notification_admin_title',
    description: 'email_template_comment_notification_admin_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, [CONTENT_URL, CONTENT_NAME, CONTENT_COMMENT])
  },
  contentRequestNotification: {
    title: 'email_template_contact_request_notification_title',
    description: 'email_template_contact_request_notification_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, [CONTENT_TITLE])
  },
  reviewNotification: {
    title: 'email_template_review_notification_title',
    description: 'email_template_review_notification_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, [CONTENT_ASSET_NAME, CONTENT_REVIEW])
  },
  userImport: {
    title: 'email_template_user_import_title',
    description: 'email_template_user_import_info',
    fields: [SUBJECT, BODY]
  },
  newReplyNotificationSubscriber: {
    title: 'email_template_new_reply_title',
    description: 'email_template_new_reply_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_NAME, CONTENT_URL, CONTENT_COMMENT])
  },
  newCommentNotificationSubscriber: {
    title: 'email_template_new_comment_title',
    description: 'email_template_new_comment_info',
    fields: [].concat(BASE_FIELDS, [SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_NAME, CONTENT_URL, CONTENT_COMMENT])
  },
  uncompletedReminder: {
    title: 'email_template_uncompleted_reminder_title',
    description: 'email_template_uncompleted_reminder_info',
    fields: BASE_FIELDS,
    overridableFields: [SUBJECT],
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  openReminder: {
    title: 'email_template_open_reminder_title',
    description: 'email_template_open_reminder_info',
    fields: BASE_FIELDS,
    overridableFields: [SUBJECT],
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  inactivityReminder: {
    title: 'email_template_inactivity_reminder_title',
    description: 'email_template_inactivity_reminder_info',
    fields: BASE_FIELDS,
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS)
  },
  invitationReminder: {
    title: 'email_template_invitation_reminder_title',
    description: 'email_template_invitation_reminder_info',
    fields: [].concat(BASE_FIELDS, [TITLE, LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [RECIPIENT_INVITE_LINK])
  },
  autoRecommendation: {
    title: 'email_template_auto_recommendation_title',
    description: 'email_template_auto_recommendation_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT]),
    placeholders: [].concat(BASE_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  recommendation: {
    title: 'email_template_recommendation_title',
    description: 'email_template_recommendation_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT]),
    overridableFields: [SUBJECT],
    placeholders: [].concat(BASE_TAGS, SENDER_TAGS, BASE_RECIPIENT_TAGS, [CONTENT_DUE_DATE])
  },
  resetRecommendation: {
    title: 'email_template_reset_recommendation_title',
    description: 'email_template_reset_recommendation_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT]),
    placeholders: [].concat(BASE_TAGS)
  }
}, isHelixEnabled && {
  meetingAnalysis: {
    title: 'email_message_type_meeting_analysis_title',
    description: 'email_message_type_meeting_analysis_info',
    fields: [].concat(BASE_FIELDS, [LINK_TEXT, SIGNATURE]),
    placeholders: [].concat(BASE_TAGS, [RECIPIENT_NAME], MEETING_TAGS)
  }
});